const defaultState = {
  homePreference: 'm',
  setting: false
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "USER_SET_HOMEPREFERENCE": {
        return {
          ...state,
          setting: true,
          homePreference: action.payload
        }
      }
      case "USER_SET_HOMEPREFERENCE_FULFILLED": {
        return {
          ...state,
          setting: false,
        }
      }
      case "USER_SET_HOMEPREFERENCE_REJECTED": {
        return {
          ...state,
          setting: false
        }
      }
      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/settingsReducer.js